import { Title } from '@gerdau/hefesto/Title';
import React from 'react';
import { IPaidByMonthState } from '../../../../store/ducks/dashboard/types';
import { DashboardItemContainer } from '../../styles';
import PaymentsByMonthChart from './PaymentsByMonthChart';

interface IPaymentsByMonthProps {
  paidByMonthState: IPaidByMonthState;
  errorMessageBlock: React.ReactNode;
}

const PaymentsByMonth: React.FC<IPaymentsByMonthProps> = ({
  paidByMonthState,
  errorMessageBlock,
  children
}) => {
  return (
    <DashboardItemContainer className="squared payments">
      <Title level={4}>Pagamentos (R$)</Title>

      {paidByMonthState.error && !paidByMonthState.loading && (
        <>{errorMessageBlock}</>
      )}

      {paidByMonthState.loading && !paidByMonthState.error && <>{children}</>}

      {!paidByMonthState.error && !paidByMonthState.loading && (
        <PaymentsByMonthChart
          paidByMonthState={paidByMonthState}
          isEmpty={paidByMonthState.data.length === 0}
        />
      )}
    </DashboardItemContainer>
  );
};

export default PaymentsByMonth;
